import * as THREE from 'three'
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'

const objLoader   = new OBJLoader()
const stlExporter = new STLExporter()

/**
 * @param {File} objFile
 * @returns {Promise<{ stlFile: File }>}
 */
export const convertObjToStl = (objFile) => new Promise((resolve, reject) => {
	const reader = new FileReader()
	reader.onload = () => {
		try {
			const loadedObject = objLoader.parse(String(reader.result ?? ''))
			let meshFound = /** @type {THREE.Mesh} */ (undefined)
			let meshCount = 0
			loadedObject.traverse(child => {
				if (child instanceof THREE.Mesh) { meshFound = child; meshCount++ }
			})
			if      (meshCount > 1)                           throw new Error('Multiple meshes found in OBJ file')
			else if (meshFound == null)                       throw new Error('No mesh found in OBJ file')
			else if (!meshFound?.geometry?.isBufferGeometry)  throw new Error('Mesh geometry is not BufferGeometry')

			const stlSrc  = stlExporter.parse(meshFound)
			const nameNoExt = objFile.name.replace(/\.[^/.]+$/, '')
			const blob    = new Blob([stlSrc], { type: 'model/stl' })
			const stlFile = new File([blob], `${nameNoExt}.stl`, { type: 'model/stl' })
			resolve({ stlFile })
		} catch (error) { reject(error) }
	}
	reader.onerror = () => reject(reader.error ?? new Error('Failed to read OBJ file'))
	reader.readAsText(objFile)
})
